import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	myOrganizationAccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	publicAccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privateAccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allProjectRoles: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownProjectGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	myOrganizationAccess: {
		id: 'directories.filters-v2.main.content.cells.access.my-organization-access',
		defaultMessage: 'My organization',
		description:
			'Table cell content displayed on Filters Directory page in Access column. It informs users that access to given filter is open - every logged in user can access this filter.',
	},
	publicAccess: {
		id: 'directories.filters-v2.main.content.cells.access.public-access',
		defaultMessage: 'Public',
		description:
			'Table cell content displayed on Filters Directory page in Access column. It informs users that access to given filter is public - everyone (even anonymous users) can access this filter.',
	},
	privateAccess: {
		id: 'directories.filters-v2.main.content.cells.access.private-access',
		defaultMessage: 'Private',
		description:
			'Table cell contents displayed on Filters Directory page in Access column. It informs users that access to given filter is private - only owner of this filter can access it.',
	},
	allProjectRoles: {
		id: 'directories.filters-v2.main.content.cells.access.all-project-roles',
		defaultMessage: 'All roles',
		description:
			'Role information displayed in Access column of Filters Directory table. It is displayed when access to given filter is limited to users having access to given project, but it is not limited by project roles, i.e. users belonging to every role in project can access it.',
	},
	unknownProject: {
		id: 'directories.filters-v2.main.content.cells.access.unknown-project',
		defaultMessage: 'Unknown project',
		description: 'UI placeholder for projects that the user does not have permissions to view',
	},
	unknownProjectGalaxia: {
		id: 'directories.filters-v2.main.content.cells.access.unknown-project-galaxia',
		defaultMessage: 'Unknown space',
		description: 'UI placeholder for projects that the user does not have permissions to view',
	},
});
export default messages;
